import React from 'react'

const Hero = () => {
    return (
                    <section className='taylor-hero'>
                    <div className="taylor-img">
                    </div>
                    <div className='taylor-text'>
                    <h1>Get <span>Swifty</span></h1>
                    <h3>Generate Taylor Swift lyrics as placeholder text</h3>
                    </div>
            </section>
    )
}

export default Hero;